import $ from "jquery";
class SimpleEventEmitter {
    constructor() {
        this.events = {};
    }
    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }
    emit(event, ...args) {
        if (this.events[event]) {
            this.events[event].forEach(listener => listener(...args));
        }
    }
    removeListener(event, listener) {
        if (this.events[event]) {
            this.events[event] = this.events[event].filter(l => l !== listener);
        }
    }
}
export default class Component extends SimpleEventEmitter {
    constructor($element) {
        super();
        this.setComponentVisibility = this.setComponentVisibility.bind(this);
        this.setComponentFormElementsState =
            this.setComponentFormElementsState.bind(this);
        this.$component = $element;
        return this;
    }
    setComponentFadeOut(duration) {
        this.$component.fadeOut(duration);
        this.setComponentVisibility(false);
        this.$component.attr("style", "");
    }
    setComponentVisibility(show) {
        this.$component.toggleClass("!u-hidden", !show);
    }
    setComponentFormElementsState(enable) {
        this.$component
            .find("input, select, textarea, button")
            .each((index, formElement) => {
            const $formElement = $(formElement);
            if ($formElement.is(":visible") &&
                !$formElement.hasClass("js-no-disable")) {
                $formElement.prop("disabled", !enable);
            }
        });
    }
}
